<template lang="pug">
#bloco-visualizar-dados(
    v-loading='!dados.length',
    element-loading-background='rgb(255 255 255 / 0%)'
)
    .bloco-visualizar-dados-container--loading
        transition(name='el-fade-in-linear', v-if='dados.length')
            .bloco-visualizar-dados-container
                h3 Visualização dos dados
                .bloco-visualizar-dados__button
                    button.el-button.el-button--default.is-round(
                        v-for='(dado, index) in dados',
                        @click='selecionarDado(dado, index)'
                    )
                        | {{ dado.nome }}
</template>

<script>
export default {
    name: 'BlocoVisualizarDados',
    emits: ['atualizar-filtro-avancado'],
    data() {
        return {
            dados: [],
            idDadosSelecionados: []
        };
    },

    mounted() {
        this.buscarDado();
    },

    methods: {
        selecionarDado(bases, index) {
            // para dados selecionados voce pode adicionar a classe abaixo no botão (linha 14)
            // bloco-visualizar-dados__button--active
            this.$emit();
        },
        buscarDado() {
            this.dados = [
                {
                    id: 3,
                    nome: 'Base Lyra',
                    codigo: 'teste_1'
                },
                {
                    id: 1,
                    nome: 'Base Carteira',
                    codigo: 'teste_2'
                }
            ];
        }
    }
};
</script>

<style lang="scss" scoped>
#bloco-visualizar-dados {
    .bloco-visualizar-dados__button--active {
        border-color: var(--secondary-two) !important;
        color: var(--white) !important;
        background: var(--secondary-two) !important;
    }
    .bloco-visualizar-dados-container {
        h3 {
            font-size: 16px;
            font-weight: 600;
            margin-bottom: 10px;
        }
        .el-button.is-round {
            margin: 2px 3px 0px 2px;
        }
        .el-button.is-round:not(:first-child) {
            margin: 2px 3px 2px 2px;
        }
        .el-button.is-round {
            box-shadow: 0px 0px 2px 0px var(--block-shadow);
            border-radius: 20px;
            padding: 9px 20px;
            min-width: 149px;
            color: var(--primary);
        }
    }

    .bloco-visualizar-dados-container--loading {
        min-height: 70px;
    }
}
</style>
